<div class="grid-container padding-y-4">
  <div class="grid-row grid-gap">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">User Profile - {{roleName}}</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false"
            aria-controls="more-actions" data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            @if (!gsaEmail) {
              <li class="usa-nav__submenu-item">
                <a (click)="goToAccount()"> Account Info</a>
              </li>
            }
            @if (isShowUserList) {
              <li class="usa-nav__submenu-item">
                <a (click)="goToUserList()"> User List </a>
              </li>
            }

            @if (isCarrierAdmin) {
              <li class="usa-nav__submenu-item">
                <a (click)="gotoCarrierContactInfo()">Shipment Booking Contact</a>
              </li>
            }

            @if (isCarrierAdmin) {
              <li class="usa-nav__submenu-item">
                <a (click)="gotoShipmentTrackingUrl()">Shipment Tracking Base URL</a>
              </li>
            }

            @if (isCarrierAdmin || isAgencyAdmin || isAgencyAuditor) {
              <li class="usa-nav__submenu-item">
                <a (click)="gotoNotificationsPrefs()">Notification Preferences</a>
              </li>
            }
          </ul>
        </li>
      </ul>
    </div>
  </div>
  @if (saveSuccessful) {
    <div class="grid-row grid-gap">
      <div class="usa-alert usa-alert--success">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            User profile has been updated successfully
          </p>
        </div>
      </div>
    </div>
  }
  <form [formGroup]="userProfileForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="auth_first_name" class="usa-label">First Name<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="auth_first_name" formControlName="firstName" class="usa-input" [maxlength]="35"
                 [ngClass]="{
                  'border-success': this.userProfileForm.get('firstName').valid && this.userProfileForm.get('firstName').touched,
                  'border-danger': this.userProfileForm.get('firstName').invalid && this.userProfileForm.get('firstName').touched
                 }">
            @if (this.userProfileForm.get('firstName').invalid) {
              <div>
                <small class="text-danger">
                  <span class="fa fa-warning"></span> First Name is required
                </small>
              </div>
            }
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="auth_middle_name" class="usa-label">Middle Initial</label>
            <input type="text" id="auth_middle_name" formControlName="middleInitial" class="usa-input" [maxlength]="1">
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="auth_last_name" class="usa-label">Last Name<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="auth_last_name" formControlName="lastName" class="usa-input" [maxlength]="35"
                 [ngClass]="{
                  'border-success': this.userProfileForm.get('lastName').valid && this.userProfileForm.get('lastName').touched,
                  'border-danger': this.userProfileForm.get('lastName').invalid && this.userProfileForm.get('lastName').touched
                 }">
              @if (this.userProfileForm.get('lastName').invalid) {
                <div>
                  <small class="text-danger">
                    <span class="fa fa-warning"></span> Last Name is required
                  </small>
                </div>
              }
            </div>
          </div>
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="auth_phone" class="usa-label">Phone<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="auth_phone" formControlName="phone" class="usa-input" [maxlength]="20" [ngClass]="{
                  'border-success': this.userProfileForm.get('phone').valid && this.userProfileForm.get('phone').touched,
                  'border-danger': this.userProfileForm.get('phone').invalid && this.userProfileForm.get('phone').touched
                 }">
                @if (this.userProfileForm.get('phone').invalid) {
                  <div>
                    <small class="text-danger">
                      <span class="fa fa-warning"></span> Phone number is invalid
                    </small>
                  </div>
                }
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="auth_ext" class="usa-label">Ext</label>
                <input type="text" id="auth_ext" formControlName="phoneExt" class="usa-input" [maxlength]="10">
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="mobilePhone" class="usa-label">Mobile Phone</label>
                <input type="text" id="mobilePhone" appNumbersOnly formControlName="mobilePhone" class="usa-input"
                  [maxlength]="10">
                </div>
              </div>
              <div class="grid-row grid-gap">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="auth_email" class="usa-label">Email<abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr></label>
                  <input type="text" id="auth_email" formControlName="email" [attr.disabled]="disabled?'':null"
                 readonly class="usa-input" [maxlength]="254" [ngClass]="{
                  'border-success': this.userProfileForm.get('email').valid && this.userProfileForm.get('email').touched,
                  'border-danger': this.userProfileForm.get('email').invalid && this.userProfileForm.get('email').touched
                 }">
                    @if (this.userProfileForm.get('email').invalid) {
                      <div>
                        <small class="text-danger">
                          <span class="fa fa-warning"></span> Email is invalid
                        </small>
                      </div>
                    }
                  </div>
                </div>
                @if (!this.showAuthOfficial) {
                  <hr>
                  }
                  @if (!this.showAuthOfficial) {
                    <div>
                      <div class="grid-row">
                        <legend class="usa-legend usa-legend--medium">Auth Official Information for Account</legend>
                      </div>
                      <div class="grid-row"><label class="usa-label">Auth Official Name : {{ pocFName ? pocFName : '' }} {{pocLName ? pocLName : '' }}</label></div>
                      <div class="grid-row"><label>Phone : {{pocPhone ? pocPhone : '' }}</label></div>
                      <div class="grid-row"><label>Email : {{pocEmail ? pocEmail : '' }}</label></div>
                      <div class="grid-row"></div>
                    </div>
                  }

                  @if (this.showAuthOfficial) {
                    <div>
                      <!--<div class="grid-row grid-gap">
                      <legend class="usa-legend usa-legend&#45;&#45;medium">Authorized Official</legend>
                    </div>-->
                    <div class="grid-row grid-gap">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="auth_title" class="usa-label">Title<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" id="auth_title" formControlName="title" class="usa-input" [maxlength]="45">
                        @if (this.showAuthOfficial && this.userProfileForm.get('title').invalid) {
                          <div>
                            <small class="text-danger">
                              <span class="fa fa-warning"></span> Title is invalid
                            </small>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="grid-row grid-gap">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="address" class="usa-label">Address<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" id="address" formControlName="address" class="usa-input" [maxlength]="45">
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="address_2" class="usa-label">Address 2</label>
                        <input type="text" id="address_2" formControlName="address2" class="usa-input" [maxlength]="45">
                      </div>
                    </div>
                    <div class="grid-row grid-gap">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label for="zip" class="usa-label">Zip Code<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" id="zip" [attr.disabled]="this.disableCityState?'':null" formControlName="zip"
                          maxlength="5" class="usa-input" (change)="getCityState($event)">
                          @if (this.userProfileForm.get('zip').invalid) {
                            <div>
                              <small class="text-danger">
                                <span class="fa fa-warning"></span> Zip code is required
                              </small>
                            </div>
                          }
                          @if (this.userProfileForm.get('zip').hasError('numeric')) {
                            <div class="text-danger">
                              <span class="fa fa-warning"></span> Invalid Zip Code
                            </div>
                          }
                          @if (invalidZip) {
                            <div class="text-danger">
                              <span class="fa fa-warning"></span> Zip code not available in USPS data
                            </div>
                          }
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                          <label for="city" class="usa-label">City<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <input type="text" id="city" formControlName="city" class="usa-input" [maxlength]="45">
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                          <label for="state" class="usa-label">State<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="state" formControlName="state" class="usa-input" title="state" name="state"
                            (change)="changeState($event)">
                            <option [value]='null' selected disabled>Choose...</option>
                            @for (s of stateList; track s) {
                              <option [value]="s.stateCountryId">{{s.stateCountryName}}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="grid-row grid-gap">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                          <label for="country" class="usa-label">Country<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="country" formControlName="country" class="usa-input" title="reporting_country"
                            (change)="changeCountry($event)" name="country">
                            <option [value]='null' selected disabled>Choose...</option>
                            @for (c of countryList; track c) {
                              <option [value]="c.stateCountryId">{{c.stateCountryName}}</option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="usa-button margin-top-2"
                    [disabled]="(!userProfileForm.dirty) || this.saveSuccessful || (this.showAuthOfficial && this.userProfileForm.invalid)"
                    (click)="updateProfile();">Update
                  </button>
                  <button type="button" class="usa-button margin-top-2" (click)="onViewAuditTrail()">View Audit Trails
                  </button>
                  @if (!gsaEmail) {
                    <button type="button" class="usa-button margin-top-2"
                      (click)="resetMfa();">Reset MFA
                    </button>
                  }
                </fieldset>
              </form>
            </div>
